import React from 'react';
import { connect } from 'react-redux';

import store from '../store';

import {
    feedsInitFieldMap,
} from '../modules/Feeds/actions';

import FieldMap from './FieldMap';

const $ = jQuery;
const { dispatch } = store;

class FieldMapList extends React.Component {
    componentDidUpdate(prevProps, prevState) {
        const { sobjectName, feeds } = this.props;

        if (sobjectName != '' && !feeds.hasOwnProperty(sobjectName)) {
            dispatch(feedsInitFieldMap(sobjectName));
        }
    }

    render() {
        const { sobjectName, feeds, status } = this.props;

        if (sobjectName == '' || !feeds.hasOwnProperty(sobjectName)) {
            return null;
        }

        const feed = feeds[sobjectName];

        return (
            <table className="settings-field-map-table">
                <tbody className="repeater">
                    {
                        feed.field_map.map((fm, idx) => {
                            if (status == 0 && idx >= 1) {
                                return null;
                            }

                            return (
                                <FieldMap key={`fm_${idx}`} idx={idx} />
                            )
                        })
                    }
                </tbody>
            </table>
        );
    }
}

const mapStateToProps = function (store) {
    return {
        sobjectName: store.metaState.get('sobject').get('name'),
        feeds: store.feedsState.get('feeds').toJS(),
        status: store.metaState.get('status'),
    }
};

export default connect(mapStateToProps)(FieldMapList);
